"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticNetworkQualitySDK = exports.MeasurementMode = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var openapi_1 = require("../../../generated/openapi");
var networkQuality_1 = require("../networkQuality");
var R = __importStar(require("ramda"));
var immer_1 = __importStar(require("immer"));
var NQError_1 = require("../NQError");
var serverData_1 = require("../util/serverData");
var NQValue_1 = require("../NQValue");
var MeasurementMode;
(function (MeasurementMode) {
    MeasurementMode["Production"] = "Production";
    // The flag cpuBenchmark set to 'false'
    MeasurementMode["Disabled_Benchmarks"] = "Disabled_Benchmarks";
    // Customer, download results are not satisfactory, modem test successfully run  
    MeasurementMode["Customer_NonSat_ModemAvailable"] = "Customer_NonSat_ModemAvailable";
    // Customer, download results are not satisfactory, modem test successfully run, provisionedDownloadSpeed < modem speed
    MeasurementMode["Customer_NonSat_ModemAvailable_SpeedLimit"] = "Customer_NonSat_ModemAvailable_SpeedLimit";
    // Customer, download results are not satisfactory, modem test successfully run, modem exchange message with a swap link was sent
    MeasurementMode["Customer_NonSat_ModemAvailable_SwapLink"] = "Customer_NonSat_ModemAvailable_SwapLink";
    // Customer, download results are not satisfactory, modem test did not run due to DCA
    MeasurementMode["Customer_NonSat_ModemNotAvailableDCA"] = "Customer_NonSat_ModemNotAvailableDCA";
    // Customer, download results are not satisfactory, modem test failed
    MeasurementMode["Customer_NonSat_ModemFailed"] = "Customer_NonSat_ModemFailed";
    // Customer, download results are satisfactory, modem test was not needed
    MeasurementMode["Customer_Sat"] = "Customer_Sat";
    // Customer, download results are satisfactory, modem test was not needed, modem exchange message with a swap link was sent
    MeasurementMode["Customer_Sat_SwapLink"] = "Customer_Sat_SwapLink";
    // Non-customer, no vpn detected
    MeasurementMode["NonCustomer_NoVpn"] = "NonCustomer_NoVpn";
    // Non-customer, vpn detected
    MeasurementMode["NonCustomer_Vpn"] = "NonCustomer_Vpn";
    // No network connectivity
    MeasurementMode["Error_Unconnected"] = "Error_Unconnected";
    // On top of NonCustomer_NoVpn scenario, an error happens during upload stage
    MeasurementMode["Error_During_Upload_NonCustomer_NoVpn"] = "Error_During_Upload_NonCustomer_NoVpn";
    // On top of Customer_NonSat_ModemAvailable, an error happens during modem stage
    MeasurementMode["Error_On_Modem_Customer_NonSat_ModemAvailable"] = "Error_On_Modem_Customer_NonSat_ModemAvailable";
    // When parallel tests are detected by the server
    MeasurementMode["Error_Parallel_Speedtests"] = "Error_Parallel_Speedtests";
    // When too high results of 2nd step are received
    MeasurementMode["Error_Too_High_Results"] = "Error_Too_High_Results";
})(MeasurementMode = exports.MeasurementMode || (exports.MeasurementMode = {}));
var SyntheticNetworkQualitySDK = /** @class */ (function (_super) {
    __extends(SyntheticNetworkQualitySDK, _super);
    function SyntheticNetworkQualitySDK(interval, dataOverride) {
        var _this = _super.call(this) || this;
        _this.interval = interval;
        _this.dataOverride = dataOverride;
        _this.getBenchmarkValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createBenchmarkIntermediate)(100),
                (0, NQValue_1.createBenchmarkFinalAvailable)(100, 200),
            ]);
        };
        _this.getDownloadValues = function () {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(function (i) { return (0, NQValue_1.createDownloadIntermediate)((90 + i) * 1e6); })
                .concat([(0, NQValue_1.createDownloadFinal)(100e6, 3e6)]));
        };
        _this.getUploadValues = function () {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(function (i) { return (0, NQValue_1.createUploadIntermediate)((15 + i) * 1e6); })
                .concat([(0, NQValue_1.createUploadFinal)(25e6, 1e6)]));
        };
        _this.getPingValues = function () {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(function (i) { return (0, NQValue_1.createPingIntermediate)((5 + i) * 1e-3); })
                .concat([(0, NQValue_1.createPingFinal)(20e-3, 1e-3)]));
        };
        _this.getCompleteValue = function () {
            return (0, immer_1.freeze)({ kind: NQValue_1.NQValueKind.Complete });
        };
        _this.getTipValues = function () {
            return (0, immer_1.freeze)((0, NQValue_1.createHints)(R.range(1, 6)
                .map(function (i) {
                var hint = _this.getHints().find(function (h) { return h.id === i; });
                return R.isNil(hint) ? {
                    id: i,
                    title: "Hint Title #".concat(i),
                    titleImageUrl: "/hint-image-url".concat(i, ".net/image.jpg"),
                    teaserTitle: "Hint Teaset Title ".concat(i),
                    teaser: "Hint Teaser ".concat(i),
                    teaserImageUrl: null,
                    contentTitle: null,
                    content: null,
                } : hint;
            })));
        };
        _this.prepare = function () {
            return (0, rxjs_1.of)(_this.createPrepareResult());
        };
        _this.calcDownload = function (data) {
            var downloadValues = _this.getDownloadValues();
            return (0, rxjs_1.of)(R.last(downloadValues));
        };
        _this.calcUpload = function (data) {
            var uploadValues = _this.getUploadValues();
            return (0, rxjs_1.of)(R.last(uploadValues));
        };
        _this.ping = function (prepareResult) {
            return emitValues(_this.getPingValues(), _this.interval);
        };
        _this.complete = function (prepareResult) {
            return (0, rxjs_1.of)(_this.getCompleteValue());
        };
        _this.abort = function (prepareResult) {
            return rxjs_1.EMPTY;
        };
        _this.modem = function (prepareResult) {
            return emitValues(_this.getModemValues(), _this.interval);
        };
        return _this;
    }
    /**
     * @param measurementMode
     * @param interval The time interval between successive emissions of NQValues in seconds.
     */
    SyntheticNetworkQualitySDK.create = function (measurementMode, logger, interval, dataOverride) {
        if (interval === void 0) { interval = 1; }
        logger.info("SyntheticNetworkQualitySDK create. measurementMode = ".concat(measurementMode));
        switch (measurementMode) {
            case MeasurementMode.Disabled_Benchmarks:
                return new Disabled_Benchmarks(interval, false, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable:
                return new Customer_NonSat_ModemAvailable(interval, false, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable_SpeedLimit:
                return new Customer_NonSat_ModemAvailable_SpeedLimit(interval, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable_SwapLink:
                return new Customer_NonSat_ModemAvailable(interval, true, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemNotAvailableDCA:
                return new Customer_NonSat_ModemNotAvailableDCA(interval, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemFailed:
                return new Customer_NonSat_ModemFailed(interval, dataOverride);
            case MeasurementMode.Customer_Sat:
                return new Customer_Sat(interval, false, dataOverride);
            case MeasurementMode.Customer_Sat_SwapLink:
                return new Customer_Sat(interval, true, dataOverride);
            case MeasurementMode.NonCustomer_Vpn:
                return new NonCustomerSyntheticNetworkQualitySDK(true, interval, dataOverride);
            case MeasurementMode.NonCustomer_NoVpn:
                return new NonCustomerSyntheticNetworkQualitySDK(false, interval, dataOverride);
            case MeasurementMode.Error_Unconnected:
                return new Error_Unconnected(interval, dataOverride);
            case MeasurementMode.Error_During_Upload_NonCustomer_NoVpn:
                return new Error_During_Upload_NonCustomer_NoVpn(interval, dataOverride);
            case MeasurementMode.Error_On_Modem_Customer_NonSat_ModemAvailable:
                return new Error_On_Modem_Customer_NonSat_ModemAvailable(interval, dataOverride);
            case MeasurementMode.Error_Parallel_Speedtests:
                return new Error_Parallel_Speedtests(interval, dataOverride);
            case MeasurementMode.Error_Too_High_Results:
                return new Error_Too_High_Results(interval, dataOverride);
            case MeasurementMode.Production:
                throw new Error("");
        }
    };
    SyntheticNetworkQualitySDK.prototype.getConfigData = function () {
        return (0, immer_1.freeze)({
            version: "0.8.2",
            remotePortDetectionUrl: "remotePortDetection",
            ipDetectionUrl: {
                ipv4: "ipDetection/ipv4",
                ipv6: "ipDetection/ipv6",
            },
            download: {
                numStreams: 6,
                duration: 1,
                interval: 0.1,
            },
            upload: {
                duration: 1,
                interval: 0.1,
                maxBytes: 10000000,
            },
            ping: {
                duration: 1,
                interval: 0.1,
            },
            cpuBenchmark: true,
            webBenchmark: false,
            tcpRetrans: true,
            isUnderMaintenance: false,
        });
    };
    SyntheticNetworkQualitySDK.prototype.getInitData = function () {
        return (0, immer_1.freeze)({
            "speedtest": {
                "id": "stid123",
                "servers": {
                    "downloadServers": {
                        "dualstack": [
                            "http://localhost/download-dualstack-1",
                            "http://localhost/download-dualstack-2"
                        ],
                        "ipv6": [
                            "http://localhost/download-ipv6-1",
                            "http://localhost/download-ipv6-2"
                        ]
                    },
                    "uploadServer": {
                        "dualstack": "http://localhost/upload-dualstack-1",
                        "ipv6": "http://localhost/upload-ipv6-1"
                    },
                    "pingServer": {
                        "dualstack": "http://localhost/ping-dualstack-1",
                        "ipv6": "http://localhost/ping-ipv6-1"
                    },
                    "wsPingServer": {
                        "dualstack": "wss://speedtest-21.vodafone.anw.net/ping/",
                        "ipv6": "wss://speedtest-21v6.vodafone.anw.net/ping/"
                    },
                    "pageSpeedServer": []
                }
            },
            "connection": {
                "ip": "127.0.0.1",
                "ipVersion": openapi_1.ConnectionModelIpVersionEnum.V4,
                "remotePort": 0,
                "isp": "Vodafone GmbH",
                "isCustomer": true,
                "ispFootprint": openapi_1.ConnectionModelIspFootprintEnum.Um,
                "isVpnActive": false,
                "vpnDetectdBy": openapi_1.ConnectionModelVpnDetectdByEnum.Customer
            },
            "modem": {
                "name": "AVM FRITZ!Box 6660",
                "type": "6490",
                "provisionedDownloadSpeed": 115000000,
                "bookedDownloadSpeedMax": 1000000000,
                "bookedDownloadSpeedAvg": 850000000,
                "bookedDownloadSpeedMin": 600000000,
                "provisionedUploadSpeed": 56710000,
                "bookedUploadSpeedMax": 50000000,
                "bookedUploadSpeedAvg": 35000000,
                "bookedUploadSpeedMin": 15000000
            },
            "cmts": {
                "vendor": "Arris",
                "isModemTestAvailable": true
            },
            "client": {
                "uuid": "uuid123",
                "userAgent": null,
                "browser": {
                    "name": "TestBrowser",
                    "version": "1.1.1",
                    "isCurrent": true
                },
                "os": {
                    "name": "testOS",
                    "version": "2.2.2",
                    "isCurrent": true
                },
                "device": {
                    "deviceType": openapi_1.DeviceModelDeviceTypeEnum.Desktop
                }
            },
            "location": {
                "countryCode": "DE"
            },
            "communication": {
                "modemSwap": false,
            },
        });
    };
    SyntheticNetworkQualitySDK.prototype.isIPv6 = function () {
        return true;
    };
    SyntheticNetworkQualitySDK.prototype.getHistoryRecords = function () {
        return (0, immer_1.freeze)([
            {
                "date": new Date("2021-09-14T08:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid0" }, "connection": { "ip": "127.0.0.1", "isp": "Vodafone GmbH", "isCustomer": true, "isVpnActive": false }, "modem": { "bookedDownloadSpeedMax": 200000000, "bookedUploadSpeedMax": 50000000 }, "cmts": { "isModemTestAvailable": true }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: {} }, "isIPv6": true },
                "benchmarkFinal": { result1: 100, result2: 200, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 100000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 25000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                modemFinal: { parallelTraffic: null, connectionType: null, modemFinal: { reason: NQValue_1.ModemNotRunReason.NotAvailable, kind: NQValue_1.ModemFinalKind.ModemFinalDidNotRun }, kind: NQValue_1.NQValueKind.ModemFinal },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-15T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid1" }, "connection": { "ip": "127.0.0.1", "isp": "Vodafone GmbH", "isCustomer": true, "isVpnActive": false }, "modem": { "bookedDownloadSpeedMax": 200000000, "bookedUploadSpeedMax": 50000000 }, "cmts": { "isModemTestAvailable": true }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: {} }, "isIPv6": true },
                "benchmarkFinal": { result1: 100, result2: 200, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 100000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 25000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": true, "connectionType": openapi_1.SnmpResultModelConnectionTypeEnum.Lan, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalAvailable, "speed": 210000000 } },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-16T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid2" }, "connection": { "ip": "127.0.0.2", "isp": "Vodafone GmbH", "isCustomer": true, "isVpnActive": false }, "modem": { "bookedDownloadSpeedMax": 200000000, "bookedUploadSpeedMax": 50000000, type: "ModemType", name: "Modem Name" }, "cmts": { "isModemTestAvailable": true, vendor: "CMTS Schmiede" }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: {} }, "isIPv6": true },
                "benchmarkFinal": { result1: 49, result2: null, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 200000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 35000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": true, "connectionType": openapi_1.SnmpResultModelConnectionTypeEnum.Wlan24, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalAvailable, "speed": 210000000 } },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-17T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid3" }, "connection": { "ip": "127.0.0.2", "isp": "Vodafone GmbH", "isCustomer": false, "isVpnActive": true }, "modem": {}, "cmts": { "isModemTestAvailable": true, vendor: "CMTS Schmiede" }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: {} }, "isIPv6": true },
                "benchmarkFinal": { result1: 49, result2: null, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 200000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 35000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": true, "connectionType": null, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalDidNotRun, "reason": NQValue_1.ModemNotRunReason.NotNeeded } },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-18T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid4" }, "connection": { "ip": "127.0.0.2", "isp": "Vodafone GmbH", "isCustomer": false, "isVpnActive": true }, "modem": {}, "cmts": { "isModemTestAvailable": true, vendor: "CMTS Schmiede" }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: {} }, "isIPv6": true },
                "benchmarkFinal": { result1: 49, result2: null, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 200000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 35000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": false, "connectionType": null, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalDidNotRun, "reason": NQValue_1.ModemNotRunReason.NotAvailable } },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-19T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid5" }, "connection": { "ip": "127.0.0.2", "isp": "Vodafone GmbH", "isCustomer": true, "isVpnActive": true }, "modem": {}, "cmts": { "isModemTestAvailable": true, vendor: "CMTS Schmiede" }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: { modemSwapLink: "https://modemSwapLink.com" } }, "isIPv6": true },
                "benchmarkFinal": { result1: 49, result2: null, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 200000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 35000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.02, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": false, "connectionType": openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalAvailable, "speed": 203000000 } },
                "hints": [2, 3, 12, 14]
            }, {
                "date": new Date("2021-09-20T18:07:03.858Z"),
                "prepareResult": { "init": { "speedtest": { "id": "stid6" }, "connection": { "ip": "127.0.0.2", "isp": "Vodafone GmbH", "isCustomer": false, "isVpnActive": true }, "modem": { "name": "Modem1", bookedDownloadSpeedMax: 100e6, provisionedDownloadSpeed: 115e6 }, "cmts": { "isModemTestAvailable": true, vendor: "CMTS Schmiede" }, "client": { "device": {}, "browser": { "name": "Zoopark", "version": "1.1.1", "isCurrent": true } }, communication: { modemSwapLink: "https://modemSwapLink.com", plannedImprovement: "2022-07-11" } }, "isIPv6": true },
                "benchmarkFinal": { result1: 49, result2: null, kind: NQValue_1.NQValueKind.BenchmarkFinalAvailable },
                "downloadFinal": { "speed": 200000000, "jitter": 3000000, "kind": NQValue_1.NQValueKind.DownloadFinal },
                "uploadFinal": { "speed": 35000000, "jitter": 1000000, "kind": NQValue_1.NQValueKind.UploadFinal },
                "pingFinal": { "pingTime": 0.03, "jitter": 0.001, "kind": NQValue_1.NQValueKind.PingFinal },
                "modemFinal": { "kind": NQValue_1.NQValueKind.ModemFinal, "parallelTraffic": true, "connectionType": openapi_1.SnmpResultModelConnectionTypeEnum.Lan, "modemFinal": { "kind": NQValue_1.ModemFinalKind.ModemFinalAvailable, "speed": 203e6 } },
                "hints": [2, 3, 12, 14]
            }
        ]);
    };
    SyntheticNetworkQualitySDK.prototype.getHints = function () {
        return (0, immer_1.freeze)([
            { id: 13 },
            { id: 0 },
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
            { id: 6 },
            { id: 7 },
            { id: 8 },
            { id: 9 },
            { id: 10 },
            { id: 11 },
            { id: 12 },
            { id: 14 },
            { id: 15 },
            { id: 16 },
            { id: 17 },
            { id: 18 },
            { id: 19 },
            { id: 20 },
            { id: 21 },
            { id: 30 },
            { id: 31 },
            { id: 32 },
            { id: 33 },
            { id: 34 },
            { id: 36 },
        ]);
    };
    SyntheticNetworkQualitySDK.prototype.createPrepareResult = function () {
        var _a, _b;
        return (0, NQValue_1.createPrepareResult)((0, serverData_1.updateServerDataConfig)(this.getConfigData(), (_a = this.dataOverride) === null || _a === void 0 ? void 0 : _a.config), (0, serverData_1.updateServerDataInit)(this.getInitData(), (_b = this.dataOverride) === null || _b === void 0 ? void 0 : _b.init), this.isIPv6());
    };
    SyntheticNetworkQualitySDK.prototype.speedtest = function () {
        var values = Array().concat([this.createPrepareResult()], this.getBenchmarkValues(), this.getDownloadValues(), this.getUploadValues(), this.getPingValues(), this.getCompleteValue(), this.getModemValues(), this.getTipValues());
        return emitValues(values, this.interval);
    };
    SyntheticNetworkQualitySDK.prototype.history = function () {
        return (0, rxjs_1.of)(this.getHistoryRecords());
    };
    SyntheticNetworkQualitySDK.prototype.historyDeleteRecord = function (speedtestId) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    SyntheticNetworkQualitySDK.prototype.historyDeleteAll = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    SyntheticNetworkQualitySDK.prototype.hints = function (speedtestId) {
        return (0, rxjs_1.of)(this.getHints());
    };
    ;
    return SyntheticNetworkQualitySDK;
}(networkQuality_1.NetworkQualitySDK));
exports.SyntheticNetworkQualitySDK = SyntheticNetworkQualitySDK;
function emitValues(values, intervalSec) {
    var timer = (0, rxjs_1.interval)(intervalSec * 1e3);
    return (0, rxjs_1.from)(values).pipe((0, operators_1.zipWith)(timer), (0, operators_1.map)(function (v) { return v[0]; }));
}
var Disabled_Benchmarks = /** @class */ (function (_super) {
    __extends(Disabled_Benchmarks, _super);
    function Disabled_Benchmarks(interval, swapLinkPresent, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.swapLinkPresent = swapLinkPresent;
        _this.getBenchmarkValues = function () {
            return [(0, NQValue_1.createBenchmarkFinalDidNotRun)()];
        };
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotNeeded)
            ]);
        };
        return _this;
    }
    Disabled_Benchmarks.prototype.getConfigData = function () {
        return (0, immer_1.default)(_super.prototype.getConfigData.call(this), function (data) {
            data.cpuBenchmark = false;
        });
    };
    return Disabled_Benchmarks;
}(SyntheticNetworkQualitySDK));
var Customer_NonSat_ModemAvailable = /** @class */ (function (_super) {
    __extends(Customer_NonSat_ModemAvailable, _super);
    function Customer_NonSat_ModemAvailable(interval, swapLinkPresent, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.swapLinkPresent = swapLinkPresent;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalAvailable)(210e6, true, openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5),
            ]);
        };
        return _this;
    }
    Customer_NonSat_ModemAvailable.prototype.getInitData = function () {
        var _this = this;
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {
                bookedDownloadSpeedMax: 200e6,
                bookedUploadSpeedMax: 50e6,
                vendor: "ModemVendor",
                type: "ModemType-SS123",
            };
            data.communication.modemSwapLink = _this.swapLinkPresent ? "http://anw.net" : null;
        });
    };
    return Customer_NonSat_ModemAvailable;
}(SyntheticNetworkQualitySDK));
var Error_On_Modem_Customer_NonSat_ModemAvailable = /** @class */ (function (_super) {
    __extends(Error_On_Modem_Customer_NonSat_ModemAvailable, _super);
    function Error_On_Modem_Customer_NonSat_ModemAvailable(interval, dataOverride) {
        var _this = _super.call(this, interval, false, dataOverride) || this;
        _this.modem = function (prepareResult) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Server);
        };
        return _this;
    }
    Error_On_Modem_Customer_NonSat_ModemAvailable.prototype.speedtest = function () {
        return _super.prototype.speedtest.call(this).pipe((0, operators_1.map)(function (v) {
            if (v.kind === NQValue_1.NQValueKind.ModemFinal) {
                throw new NQError_1.NQError(NQError_1.NQErrorCode.Server);
            }
            else {
                return v;
            }
        }));
    };
    return Error_On_Modem_Customer_NonSat_ModemAvailable;
}(Customer_NonSat_ModemAvailable));
var Customer_NonSat_ModemAvailable_SpeedLimit = /** @class */ (function (_super) {
    __extends(Customer_NonSat_ModemAvailable_SpeedLimit, _super);
    function Customer_NonSat_ModemAvailable_SpeedLimit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modemSpeed = 210e6;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalAvailable)(_this.modemSpeed, false, openapi_1.SnmpResultModelConnectionTypeEnum.Lan),
            ]);
        };
        return _this;
    }
    Customer_NonSat_ModemAvailable_SpeedLimit.prototype.getInitData = function () {
        var _this = this;
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {
                provisionedDownloadSpeed: _this.modemSpeed / 2,
                bookedDownloadSpeedMax: 200e6,
                bookedUploadSpeedMax: 50e6,
                vendor: "ModemVendor",
                type: "ModemType-SS123",
            };
        });
    };
    return Customer_NonSat_ModemAvailable_SpeedLimit;
}(SyntheticNetworkQualitySDK));
var Customer_NonSat_ModemNotAvailableDCA = /** @class */ (function (_super) {
    __extends(Customer_NonSat_ModemNotAvailableDCA, _super);
    function Customer_NonSat_ModemNotAvailableDCA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotAvailable),
            ]);
        };
        return _this;
    }
    Customer_NonSat_ModemNotAvailableDCA.prototype.getInitData = function () {
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.cmts = { isModemTestAvailable: false };
            data.modem = {
                bookedDownloadSpeedMax: 200e6,
                bookedUploadSpeedMax: 50e6
            };
        });
    };
    return Customer_NonSat_ModemNotAvailableDCA;
}(SyntheticNetworkQualitySDK));
var Customer_NonSat_ModemFailed = /** @class */ (function (_super) {
    __extends(Customer_NonSat_ModemFailed, _super);
    function Customer_NonSat_ModemFailed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalFailed)("synthetic failure"),
            ]);
        };
        return _this;
    }
    Customer_NonSat_ModemFailed.prototype.getInitData = function () {
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {
                bookedDownloadSpeedMax: 200e6,
                bookedUploadSpeedMax: 50e6
            };
        });
    };
    return Customer_NonSat_ModemFailed;
}(SyntheticNetworkQualitySDK));
var Customer_Sat = /** @class */ (function (_super) {
    __extends(Customer_Sat, _super);
    function Customer_Sat(inverval, swapLinkPresent, dataOverride) {
        var _this = _super.call(this, inverval, dataOverride) || this;
        _this.swapLinkPresent = swapLinkPresent;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotNeeded)
            ]);
        };
        return _this;
    }
    Customer_Sat.prototype.getInitData = function () {
        var _this = this;
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {
                bookedDownloadSpeedMax: 100e6,
                bookedUploadSpeedMax: 25e6
            },
                data.communication.modemSwapLink = _this.swapLinkPresent ? "http://anw.net" : null;
        });
    };
    return Customer_Sat;
}(SyntheticNetworkQualitySDK));
var NonCustomerSyntheticNetworkQualitySDK = /** @class */ (function (_super) {
    __extends(NonCustomerSyntheticNetworkQualitySDK, _super);
    function NonCustomerSyntheticNetworkQualitySDK(isVpn, interval, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.isVpn = isVpn;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotACustomer)
            ]);
        };
        return _this;
    }
    NonCustomerSyntheticNetworkQualitySDK.prototype.getInitData = function () {
        var _this = this;
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {};
            data.connection.remotePort = null;
            data.connection.isCustomer = false;
            data.connection.ispFootprint = undefined;
            data.connection.isVpnActive = _this.isVpn;
        });
    };
    return NonCustomerSyntheticNetworkQualitySDK;
}(SyntheticNetworkQualitySDK));
var Error_During_Upload_NonCustomer_NoVpn = /** @class */ (function (_super) {
    __extends(Error_During_Upload_NonCustomer_NoVpn, _super);
    function Error_During_Upload_NonCustomer_NoVpn(interval, dataOverride) {
        return _super.call(this, false, interval, dataOverride) || this;
    }
    Error_During_Upload_NonCustomer_NoVpn.prototype.speedtest = function () {
        return _super.prototype.speedtest.call(this).pipe((0, operators_1.map)(function (v) {
            if (v.kind === NQValue_1.NQValueKind.UploadFinal) {
                throw new NQError_1.NQError(NQError_1.NQErrorCode.Server);
            }
            else {
                return v;
            }
        }));
    };
    return Error_During_Upload_NonCustomer_NoVpn;
}(NonCustomerSyntheticNetworkQualitySDK));
var Error_Unconnected = /** @class */ (function (_super) {
    __extends(Error_Unconnected, _super);
    function Error_Unconnected(interval, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.prepare = function () {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.calcDownload = function (data) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.calcUpload = function (data) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.ping = function (prepareResult) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.complete = function (prepareResult) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.abort = function (prepareResult) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        _this.modem = function (prepareResult) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        };
        return _this;
    }
    Error_Unconnected.prototype.getModemValues = function () {
        return [];
    };
    Error_Unconnected.prototype.speedtest = function () {
        return (0, rxjs_1.from)([1]).pipe((0, operators_1.delay)(this.interval), (0, operators_1.map)(function (_) {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity);
        }));
    };
    return Error_Unconnected;
}(SyntheticNetworkQualitySDK));
var Error_Parallel_Speedtests = /** @class */ (function (_super) {
    __extends(Error_Parallel_Speedtests, _super);
    function Error_Parallel_Speedtests(interval, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.prepare = function () {
            throw new NQError_1.NQError(NQError_1.NQErrorCode.ParallelSpeedtests);
        };
        return _this;
    }
    Error_Parallel_Speedtests.prototype.speedtest = function () {
        return _super.prototype.speedtest.call(this).pipe((0, operators_1.map)(function (v) {
            if (v.kind === NQValue_1.NQValueKind.PrepareResult) {
                throw new NQError_1.NQError(NQError_1.NQErrorCode.ParallelSpeedtests);
            }
            else {
                return v;
            }
        }));
    };
    return Error_Parallel_Speedtests;
}(Customer_NonSat_ModemNotAvailableDCA));
var Error_Too_High_Results = /** @class */ (function (_super) {
    __extends(Error_Too_High_Results, _super);
    function Error_Too_High_Results(interval, dataOverride) {
        var _this = _super.call(this, interval, dataOverride) || this;
        _this.getModemValues = function () {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalFailed)("Too high result (synthetic failure)"),
            ]);
        };
        return _this;
    }
    Error_Too_High_Results.prototype.getInitData = function () {
        var bookedDownloadSpeedMax = 200e6;
        return (0, immer_1.default)(_super.prototype.getInitData.call(this), function (data) {
            data.modem = {
                bookedDownloadSpeedMax: bookedDownloadSpeedMax,
                bookedUploadSpeedMax: 50e6,
                vendor: "ModemVendor",
                type: "ModemType-SS123",
            };
        });
    };
    return Error_Too_High_Results;
}(SyntheticNetworkQualitySDK));
//# sourceMappingURL=syntheticNetworkQuality.js.map